import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/benefis/benefisAction";
import * as uiHelpers from "../BenefisUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useBenefisUIContext } from "../BenefisUIContext";
import { BlockOrg, RoleChecker } from "../../../../RoleChecker";
import { BenefisDeleteDialog } from "../benefis-delete-dialog/BenefisDeleteDialog";
// import { ToastContainer } from 'react-toastify';

const BenefisTable = (props) => {
  // Benefis UI Context
  const benefisUIContext = useBenefisUIContext();
  const benefisUIProps = useMemo(() => {
    return {
      queryParams: benefisUIContext.queryParams,
      setQueryParams: benefisUIContext.setQueryParams,
      newBenefisIndividuButtonClick:
        benefisUIContext.newBenefisIndividuButtonClick,
      openDeleteBenefisPage: benefisUIContext.openDeleteBenefisPage,
      openEditBenefisIndividualPage:
        benefisUIContext.openEditBenefisIndividualPage,
      openEditBenefisOrganizationPage:
        benefisUIContext.openEditBenefisOrganizationPage,
    };
  }, [benefisUIContext]);

  // Getting curret state of benefis list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.benefis }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchBenefiss(benefisUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benefisUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "benefis_category");

  // ? Modal
  const [deleteModal, setDeleteModal] = useState(false);
  const [rowId, setRowId] = useState("");

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "benefis_category.name",
      text: "Kategori",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "type",
      text: "Tipe",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "qty",
      text: "Jumlah",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        newBenefisIndividuButtonClick:
          benefisUIProps.newBenefisIndividuButtonClick,
        openDeleteBenefisPage: benefisUIProps.openDeleteBenefisPage,
        openEditBenefisIndividualPage:
          benefisUIProps.openEditBenefisIndividualPage,
        openEditBenefisOrganizationPage:
          benefisUIProps.openEditBenefisOrganizationPage,
        allowEdit,
        setDeleteModal,
        setRowId,
        blockOrg: BlockOrg(),
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: benefisUIProps.queryParams.pageSize,
    page: benefisUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <BenefisDeleteDialog
        show={deleteModal}
        id={rowId}
        onHide={() => {
          setDeleteModal(false);
          setRowId("");
        }}
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  benefisUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default BenefisTable;
